import { MenuSelect } from '@/pages/reports/ats-reports/components/menu-select';
import { useState, useEffect } from 'react';

const defaultOptions = [
  { id: null, label: 'None' },
  { id: 'channel', label: 'Channel' },
  { id: 'recruiter', label: 'Recruiter' },
  { id: 'school', label: 'School' },
  { id: 'source', label: 'Source' },
];

export const BreakdownBy = ({
  options = defaultOptions,
  isEditMode = false,
  isPortal = false,
  selected = null,
  onChange = () => {},
}) => {
  const [currSelected, setSelected] = useState(options[0]);
  const onSelect = (option) => {
    setSelected(option);
    onChange(option);
  };

  useEffect(() => {
    if (selected) {
      const currSelected = options?.find((option) => option.id === selected);
      setSelected(currSelected);
    }
  }, [selected]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <MenuSelect
      editMode={isEditMode}
      options={options}
      selected={currSelected}
      onSelect={onSelect}
      prefix="Breakdown by"
      isPortal={isPortal}
    />
  );
};
